import { render } from "./GridCentreCost.vue?vue&type=template&id=4d9dd05a&ts=true"
import script from "./GridCentreCost.vue?vue&type=script&lang=ts"
export * from "./GridCentreCost.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__